import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import * as trimCanvasMod from "trim-canvas";

import { notifyUser } from "../utils/notifyUser";

const trimCanvas = trimCanvasMod.default || trimCanvasMod;

export default function EntrepreneurTermsNConditions({ onBack, onSuccess }) {
    /* ───────────────────────── STATE ───────────────────────── */
    const sigRef = useRef(null);
    const [typedName, setName] = useState("");
    const today = () => new Date().toISOString().slice(0, 10);
    const [sigDate, setDate] = useState(today());
    const [agreed, setAgreed] = useState(false);
    const [padHasInk] = useState(false);

    /* ───────────────────────── HELPERS ─────────────────────── */

    const onContinue = () => {
        if(!agreed) {
            notifyUser(null, "error", "Please accept the terms.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }
        if(!typedName.trim() && !padHasInk) {
            notifyUser(null, "error", "Enter your full name.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }
        if(!sigDate) {
            notifyUser(null, "error", "Please select a date.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }

        /* Decide what we’re saving */
        let sigDataUrl = "";
        if(padHasInk) {
            const raw = sigRef.current.getCanvas();
            const trimmed = trimCanvas(raw);
            sigDataUrl = trimmed.toDataURL("image/png");
        }
        localStorage.setItem("entrepreneurSignatureName", typedName.trim());
        localStorage.setItem("entrepreneurSignatureDate", sigDate);
        localStorage.setItem("entrepreneurSignature", sigDataUrl);

        onSuccess();
    };
    /* ───────────────────────── RENDER ──────────────────────── */
    return (
        <div className="relative flex justify-center font-poppins">
            <div className="w-full max-w-3xl px-2 py-4 mx-auto text-center">
                <img
                    src="images/AeQuitas-Logo-blue-with-text.png"
                    alt="AQI Logo"
                    className="w-48 mx-auto mb-2 sm:mb-4 sm:w-60 md:w-72"
                />

                <h1 className="text-3xl font-bold text-navy">
                    Terms and Conditions
                </h1>

                {/* Signature area */}
                <div className="mb-6 space-y-2 text-left">
                    <label className="block text-navy font-semibold mb-1 mt-4">
                        Enter your full name below:
                    </label>
                    <input
                        type="text"
                        value={typedName}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your full name"
                        className="w-full px-4 py-2 border border-navy rounded-lg"
                    />

                    <label className="block text-navy font-semibold mb-1 mt-4">
                        Date:
                    </label>
                    <input
                        type="date"
                        value={sigDate}
                        onChange={(e) => setDate(e.target.value)}
                        className="w-full px-4 py-2 border border-navy rounded-lg"
                    />
                </div>

                {/* Agreement */}
                <div className="flex items-start gap-2 mb-6 text-left">
                    <input
                        type="checkbox"
                        id="agree"
                        checked={agreed}
                        onChange={() => setAgreed(!agreed)}
                        className="mt-1"
                    />
                    <label htmlFor="agree" className="text-navy text-sm">
                        <p className="max-w-2xl text-navy leading-relaxed">
                            By continuing, you agree to the&nbsp;
                            <a
                                href="/docs/customer_relationship_summary_10_2026.pdf"
                                target="_blank"
                                rel="noopener"
                                className="text-navy underline"
                            >
                                Customer Relationship Summary
                            </a>
                            &nbsp;,&nbsp;
                            <a
                                href="/docs/electronic_delivery_of_documents_11_2025.pdf"
                                target="_blank"
                                rel="noopener"
                                className="text-navy underline"
                            >
                                Consent to Electronic Delivery
                            </a>
                            &nbsp;,&nbsp;
                            <a
                                href="/docs/terms_of_use_10_2026.pdf"
                                target="_blank"
                                rel="noopener"
                                className="text-navy underline"
                            >
                                Terms and Conditions
                            </a>
                            , and&nbsp;
                            <a
                                href="/docs/privacy_policy_10_2026.pdf"
                                target="_blank"
                                rel="noopener"
                                className="text-navy0 underline"
                            >
                                Privacy Policy
                            </a>
                            .
                        </p>
                    </label>
                </div>

                {/* Actions */}
                <div className="flex justify-between mt-6">
                    <button
                        onClick={onBack}
                        className="rounded-[6px] border border-navy bg-white px-5 py-3 font-semibold text-navy transition hover:bg-paper"
                    >
                        BACK
                    </button>

                    <button
                        onClick={onContinue}
                        className={`rounded-[6px] px-5 py-3 font-semibold shadow-sm transition ${
                            agreed
                                ? "bg-navy text-paper hover:bg-navy-2"
                                : "cursor-not-allowed bg-gray-300 text-gray-500"
                        }`}
                    >
                        Continue to Application
                    </button>
                </div>
            </div>
        </div>
    );
}

EntrepreneurTermsNConditions.propTypes = {
    onBack: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};
